import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgPuzzelFlower = (props) => /* @__PURE__ */ _jsxs("svg", {
	viewBox: "0 0 251 234",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsxs("g", {
		clipPath: "url(#clip0_8741_8)",
		filter: "url(#filter0_dddd_8741_8)",
		children: [
			/* @__PURE__ */ _jsx("path", {
				d: "M132.509 268.529C132.459 268.254 132.434 267.979 132.384 267.703C131.783 264.327 130.433 261.075 128.382 258.198C127.256 256.622 125.905 255.147 124.354 253.846L118.351 248.793C116.25 247.017 114.524 244.966 113.198 242.715C110.747 238.537 109.646 233.735 110.021 228.982C110.071 228.207 110.172 227.431 110.322 226.656C110.572 225.255 110.947 223.854 111.447 222.479C112.373 220.052 113.698 217.726 115.474 215.6C117.25 213.499 119.302 211.773 121.553 210.447C127.656 206.845 135.135 206.195 141.789 208.696C144.24 209.622 146.567 210.947 148.668 212.723C150.769 214.499 152.495 216.55 153.82 218.802C154.971 220.728 155.797 222.804 156.347 224.955C157.523 229.583 157.272 234.51 155.571 239.038C154.646 241.464 153.32 243.815 151.544 245.916L132.534 268.554L132.509 268.529Z",
				fill: "#DBACF5"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M40.5831 228.607C40.7582 228.382 40.9083 228.157 41.0834 227.932C43.0345 225.13 44.4102 221.853 44.9855 218.376C45.3107 216.45 45.3858 214.474 45.2107 212.448L44.5353 204.619C44.2852 201.867 44.5353 199.216 45.1857 196.689C46.3863 191.987 49.0378 187.835 52.6398 184.708C53.2401 184.208 53.8404 183.732 54.4908 183.282C55.6664 182.457 56.9171 181.731 58.2428 181.131C60.6191 180.055 63.1955 179.355 65.9471 179.105C68.6986 178.855 71.35 179.105 73.8764 179.755C80.7552 181.531 86.4833 186.359 89.4099 192.812C90.4855 195.189 91.1859 197.765 91.436 200.517C91.6862 203.268 91.436 205.919 90.7857 208.446C90.2354 210.622 89.3599 212.673 88.2343 214.574C85.7829 218.676 82.156 221.978 77.7285 223.979C75.3522 225.055 72.7508 225.755 70.0243 226.006L40.5831 228.557V228.607Z",
				fill: "#DBACF5"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M3.81299 135.381C4.08814 135.331 4.36329 135.306 4.63844 135.256C8.0153 134.655 11.2671 133.305 14.1437 131.254C15.7195 130.128 17.1953 128.777 18.496 127.226L23.5488 121.223C25.3248 119.122 27.3759 117.396 29.6272 116.07C33.8045 113.619 38.6071 112.518 43.3597 112.893C44.1351 112.943 44.9106 113.044 45.686 113.194C47.0867 113.444 48.4875 113.819 49.8633 114.319C52.2896 115.245 54.6159 116.57 56.742 118.346C58.8432 120.122 60.5691 122.174 61.8949 124.425C65.4969 130.528 66.1472 138.007 63.6458 144.661C62.7203 147.112 61.3946 149.439 59.6186 151.54C57.8427 153.641 55.7915 155.367 53.5403 156.693C51.6142 157.843 49.5381 158.669 47.3869 159.219C42.7594 160.395 37.8317 160.144 33.3042 158.443C30.8778 157.518 28.5266 156.192 26.4254 154.416L3.81299 135.381Z",
				fill: "#DBACF5"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M43.7349 43.4553C43.96 43.6304 44.1851 43.7805 44.4102 43.9556C47.2118 45.9066 50.4886 47.2824 53.9655 47.8577C55.8915 48.1829 57.8676 48.2579 59.8937 48.0828L67.723 47.4075C70.4745 47.1573 73.126 47.4075 75.6524 48.0578C80.355 49.2585 84.5072 51.9099 87.634 55.5119C88.1342 56.1122 88.6095 56.7126 89.0598 57.3629C89.8852 58.5386 90.6106 59.7893 91.2109 61.115C92.2865 63.4913 92.9869 66.0677 93.237 68.8192C93.4872 71.5707 93.237 74.2222 92.5867 76.7486C90.8107 83.6273 85.9831 89.3555 79.5295 92.2821C77.1532 93.3577 74.5768 94.0581 71.8253 94.3082C69.0738 94.5583 66.4223 94.3082 63.8959 93.6579C61.7197 93.1076 59.6686 92.2321 57.7676 91.1065C53.6653 88.6551 50.3635 85.0281 48.3624 80.6007C47.2868 78.2244 46.5864 75.623 46.3363 72.8965L43.7849 43.4553H43.7349Z",
				fill: "#DBACF5"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M136.961 6.68512C137.011 6.96027 137.036 7.23542 137.086 7.51057C137.687 10.8874 139.037 14.1392 141.088 17.0158C142.214 18.5917 143.565 20.0675 145.116 21.3682L151.119 26.421C153.22 28.1969 154.946 30.2481 156.272 32.4993C158.723 36.6766 159.824 41.4792 159.449 46.2318C159.399 47.0073 159.298 47.7827 159.148 48.5581C158.898 49.9589 158.523 51.3596 158.023 52.7354C157.097 55.1617 155.772 57.488 153.996 59.6142C152.22 61.7403 150.168 63.4413 147.917 64.767C141.814 68.369 134.335 69.0193 127.681 66.518C125.23 65.5925 122.903 64.2667 120.802 62.4908C118.701 60.7148 116.975 58.6637 115.65 56.4124C114.499 54.4864 113.673 52.4102 113.123 50.259C111.947 45.6315 112.198 40.7038 113.899 36.1763C114.824 33.75 116.15 31.3987 117.926 29.2975L136.961 6.68512Z",
				fill: "#DBACF5"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M228.887 46.607C228.711 46.8321 228.561 47.0573 228.386 47.2824C226.435 50.0839 225.059 53.3607 224.484 56.8376C224.159 58.7637 224.084 60.7398 224.259 62.7659L224.934 70.5952C225.185 73.3467 224.934 75.9982 224.284 78.5245C223.083 83.2271 220.432 87.3794 216.83 90.5061C216.23 91.0064 215.629 91.4817 214.979 91.9319C213.803 92.7574 212.553 93.4828 211.227 94.0831C208.851 95.1587 206.274 95.8591 203.523 96.1092C200.771 96.3593 198.12 96.1092 195.593 95.4589C188.715 93.6829 182.986 88.8552 180.06 82.4017C178.984 80.0254 178.284 77.449 178.034 74.6974C177.784 71.9459 178.034 69.2945 178.684 66.7681C179.234 64.5919 180.11 62.5408 181.235 60.6397C183.687 56.5375 187.314 53.2357 191.741 51.2346C194.117 50.159 196.719 49.4586 199.445 49.2085L228.887 46.6571V46.607Z",
				fill: "#DBACF5"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M265.657 139.833C265.382 139.883 265.106 139.908 264.831 139.958C261.454 140.559 258.203 141.909 255.326 143.96C253.75 145.086 252.274 146.437 250.974 147.988L245.921 153.991C244.145 156.092 242.094 157.818 239.843 159.144C235.665 161.595 230.863 162.696 226.11 162.321C225.335 162.27 224.559 162.17 223.784 162.02C222.383 161.77 220.982 161.395 219.606 160.895C217.18 159.969 214.854 158.643 212.728 156.868C210.627 155.092 208.901 153.04 207.575 150.789C203.973 144.686 203.323 137.207 205.824 130.553C206.749 128.102 208.075 125.775 209.851 123.674C211.627 121.573 213.678 119.847 215.929 118.521C217.856 117.371 219.932 116.545 222.083 115.995C226.71 114.819 231.638 115.07 236.166 116.77C238.592 117.696 240.943 119.022 243.044 120.798L265.682 139.808L265.657 139.833Z",
				fill: "#DBACF5"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M225.735 231.759C225.51 231.584 225.285 231.434 225.059 231.258C222.258 229.307 218.981 227.932 215.504 227.356C213.578 227.031 211.602 226.956 209.576 227.131L201.747 227.807C198.995 228.057 196.344 227.807 193.817 227.156C189.115 225.956 184.962 223.304 181.836 219.702C181.335 219.102 180.86 218.501 180.41 217.851C179.585 216.675 178.859 215.425 178.259 214.099C177.183 211.723 176.483 209.146 176.233 206.395C175.983 203.643 176.233 200.992 176.883 198.465C178.659 191.587 183.487 185.859 189.94 182.932C192.317 181.856 194.893 181.156 197.644 180.906C200.396 180.656 203.047 180.906 205.574 181.556C207.75 182.106 209.801 182.982 211.702 184.108C215.804 186.559 219.106 190.186 221.107 194.613C222.183 196.99 222.883 199.591 223.133 202.318L225.685 231.759H225.735Z",
				fill: "#DBACF5"
			})
		]
	}), /* @__PURE__ */ _jsxs("defs", { children: [/* @__PURE__ */ _jsxs("filter", {
		id: "filter0_dddd_8741_8",
		x: .216233,
		y: .210931,
		width: 324.427,
		height: 306.443,
		filterUnits: "userSpaceOnUse",
		colorInterpolationFilters: "sRGB",
		children: [
			/* @__PURE__ */ _jsx("feFlood", {
				floodOpacity: 0,
				result: "BackgroundImageFix"
			}),
			/* @__PURE__ */ _jsx("feColorMatrix", {
				in: "SourceAlpha",
				type: "matrix",
				values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
				result: "hardAlpha"
			}),
			/* @__PURE__ */ _jsx("feOffset", {
				dx: 2.8774,
				dy: 1.4387
			}),
			/* @__PURE__ */ _jsx("feGaussianBlur", { stdDeviation: 3.23708 }),
			/* @__PURE__ */ _jsx("feColorMatrix", {
				type: "matrix",
				values: "0 0 0 0 0.27451 0 0 0 0 0.156863 0 0 0 0 0.32549 0 0 0 0.05 0"
			}),
			/* @__PURE__ */ _jsx("feBlend", {
				mode: "normal",
				in2: "BackgroundImageFix",
				result: "effect1_dropShadow_8741_8"
			}),
			/* @__PURE__ */ _jsx("feColorMatrix", {
				in: "SourceAlpha",
				type: "matrix",
				values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
				result: "hardAlpha"
			}),
			/* @__PURE__ */ _jsx("feOffset", {
				dx: 10.0709,
				dy: 5.03546
			}),
			/* @__PURE__ */ _jsx("feGaussianBlur", { stdDeviation: 5.75481 }),
			/* @__PURE__ */ _jsx("feColorMatrix", {
				type: "matrix",
				values: "0 0 0 0 0.27451 0 0 0 0 0.156863 0 0 0 0 0.32549 0 0 0 0.04 0"
			}),
			/* @__PURE__ */ _jsx("feBlend", {
				mode: "normal",
				in2: "effect1_dropShadow_8741_8",
				result: "effect2_dropShadow_8741_8"
			}),
			/* @__PURE__ */ _jsx("feColorMatrix", {
				in: "SourceAlpha",
				type: "matrix",
				values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
				result: "hardAlpha"
			}),
			/* @__PURE__ */ _jsx("feOffset", {
				dx: 23.0192,
				dy: 11.5096
			}),
			/* @__PURE__ */ _jsx("feGaussianBlur", { stdDeviation: 7.55318 }),
			/* @__PURE__ */ _jsx("feColorMatrix", {
				type: "matrix",
				values: "0 0 0 0 0.27451 0 0 0 0 0.156863 0 0 0 0 0.32549 0 0 0 0.03 0"
			}),
			/* @__PURE__ */ _jsx("feBlend", {
				mode: "normal",
				in2: "effect2_dropShadow_8741_8",
				result: "effect3_dropShadow_8741_8"
			}),
			/* @__PURE__ */ _jsx("feColorMatrix", {
				in: "SourceAlpha",
				type: "matrix",
				values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
				result: "hardAlpha"
			}),
			/* @__PURE__ */ _jsx("feOffset", {
				dx: 41.003,
				dy: 20.1418
			}),
			/* @__PURE__ */ _jsx("feGaussianBlur", { stdDeviation: 8.99189 }),
			/* @__PURE__ */ _jsx("feColorMatrix", {
				type: "matrix",
				values: "0 0 0 0 0.27451 0 0 0 0 0.156863 0 0 0 0 0.32549 0 0 0 0.01 0"
			}),
			/* @__PURE__ */ _jsx("feBlend", {
				mode: "normal",
				in2: "effect3_dropShadow_8741_8",
				result: "effect4_dropShadow_8741_8"
			}),
			/* @__PURE__ */ _jsx("feBlend", {
				mode: "normal",
				in: "SourceGraphic",
				in2: "effect4_dropShadow_8741_8",
				result: "shape"
			})
		]
	}), /* @__PURE__ */ _jsx("clipPath", {
		id: "clip0_8741_8",
		children: /* @__PURE__ */ _jsx("rect", {
			width: 261.844,
			height: 261.844,
			fill: "white",
			transform: "translate(3.81299 6.68509)"
		})
	})] })]
});
export default SvgPuzzelFlower;
